<ckeditor 
[(ngModel)]="data"
id="editor"
[config]="config"
></ckeditor>

